import { removeRefreshToken } from './user';
import {
  LOGIN_SUCCESS, USER_SUCCESS, ACCOUNT_ACTIVATION_SUCCESS, ACCOUNT_ACTIVATION_FAIL,
} from '../reducers/user';
import { TOKEN_VALID, TOKEN_INVALID } from '../reducers/reset-password';

export function requestResetPasswordLink(fields, captcha) {
  return (_, __, api) => api.post('/account/password/reset', fields, {
    'g-recaptcha-response': captcha,
  });
}

export function resetPassword(fields, token = null) {
  return (dispatch, _, api) => api.put('/account/password/reset', fields, (token ? { 'X-Auth-Token': token } : {}))
    .then((response) => {
      api.setAuthToken(response.authToken);
      removeRefreshToken();

      dispatch([
        { type: LOGIN_SUCCESS },
        {
          type: USER_SUCCESS,
          payload: {
            profile: {
              username: response.username,
            },
          },
        }]);
    });
}

export function validateToken(token) {
  return (dispatch, _, api) => api.head('/account', (token ? { 'X-Auth-Token': token } : {}))
    .then(() => {
      dispatch({ type: TOKEN_VALID });
    })
    .catch(() => {
      dispatch({ type: TOKEN_INVALID });
    });
}

export function requestActivateAccountLink() {
  return (_, __, api) => api.post('/account/profile/verify-email');
}

export function activateAccount(token) {
  return (dispatch, _, api) => api.put('/account/profile/verify-email', {}, (token ? { 'X-Auth-Token': token } : {}))
    .then(() => {
      dispatch({
        type: ACCOUNT_ACTIVATION_SUCCESS,
      });

      return true;
    })
    .catch((err) => {
      let error = '';

      if ([401, 403].includes(err.status)) {
        error = 'Invalid or expired token.';
      }

      dispatch({ type: ACCOUNT_ACTIVATION_FAIL, payload: error });

      return true;
    });
}

export function validatePassword(formValues, token = null) {
  return (dispatch, _, api) => api.post('/account/password/validate', formValues, (token ? { 'X-Auth-Token': token } : {}));
}

export function validateProfile(fields) {
  return (dispatch, _, api) => api.post('/account/profile/validate', fields);
}

export function validateAccount(postData, headers = {}) {
  return (dispatch, _, api) => api.post('/account/validate', postData, headers);
}

export function getAccountStatements(toOperationalTime = '') {
  return (dispatch, _, api) => {
    const query = toOperationalTime ? `?toOperationalTime=${toOperationalTime}` : '';
    return api.get(`/account/statement${query}`);
  };
}

export function validateEmail(formValues) {
  return (dispatch, _, api) => api.post('/account/profile/email/validate', formValues);
}

export function updateEmail(formValues) {
  return (dispatch, _, api) => api.put('/account/profile/email', formValues);
}
